var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoseImageNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M896,256H768v64H896V832H256V736H192V864a32,32,0,0,0,32,32H928a32,32,0,0,0,32-32V288a32,32,0,0,0-32-32Z",
    style: {
      fill: "#96a2b1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 320,
    r: 64,
    style: {
      fill: "#5b6673"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796,128H100a36,36,0,0,0-36,36V732a36,36,0,0,0,36,36H796a36,36,0,0,0,36-36V164A36,36,0,0,0,796,128Zm-28,64V459.9L529.62,558.74,398.88,401.86a32,32,0,0,0-36.46-9.23L128,486.4V192ZM128,704v-147L368,456,577.85,704Zm522.67,0-81.1-97.32L768,524V704Z",
    style: {
      fill: "#5b6673"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoseImageNormal);
export default __webpack_public_path__ + "static/media/pose_image_normal.e2e240f592c925fb36395676a7ae4c9e.svg";
export { ForwardRef as ReactComponent };